<template>
  
  <div class="page with-header page-no-flex">
    <!-- <div :class="{'v-overlay--active':menuOpen}" class="v-overlay"></div> -->
    <SideMenu/>
    <div class="page-inner" :class="{'page-inner-full':!menuOpen}">
      <div class="gradient-theme md-card md-card-header md-card-header-theme new-head-fixed">
        <div class="menu pr-3">
          <router-link to="home">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="feather  trans"><polyline points="15 18 9 12 15 6"></polyline></svg>
          </router-link>
        </div>
        <h3 class="title new-head-title"><strong>Sunway Leo Cubs</strong></h3>
      </div>
      <div style="margin-top:50px"></div>
      <div class="main md-scrollbar pb-4 px-3 px-md-4">
        <LeoCubsForm/>
      </div>
    </div>
  </div>

</template>
<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import LeoCubsForm from '../components/LeoCubsForm.vue';
import Interests from '../components/Interests.vue';
import Header from "../components/common/Header.vue";
import Footer from "../components/common/Footer.vue";
import SideMenu from '@/components/common/SideMenu.vue';
import store from "./../store";

@Component({
  components: {
    LeoCubsForm, Interests, Header, Footer,SideMenu
  },
})
export default class LeoCubsPage extends Vue {
  
  constructor(){
    super()    
  }
  created(){
     window.scrollTo(0,0);

     console.log("LeoCubs ...")
  }

  get menuOpen() {
    return store.state.menu.open;
  }
}
</script>
